import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  titleCodes,
  imageCodes,
  videoCodes,
  textCodes,
} from "../../template_codes/bond/membership_page_codes";

function Membership() {
  return (
    <div>
      <div class="navbar ">
        <div class="navbar-start"></div>
        <div class="navbar-center lg:flex">
          <ul class="menu menu-horizontal">
            <li className="p-1">
              <Link to={paths.home}>Home</Link>
            </li>
            <li>
              <a href="https://bondmyanmar.com/">Shop</a>
            </li>
            <li className="p-1">
              <Link to={paths.membership}>Membership</Link>
            </li>
            <li className="p-1">
              <Link to={paths.contact}>Contact</Link>
            </li>
          </ul>
        </div>
        <div className="navbar-end"></div>
      </div>
      <div className="container w-4/5 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8">
          <div className="place-content-end ...">
            <img
              src={imageCodes.pointImg.image}
              alt="Digital Membership"
              className="place-content-end ..."
            ></img>
          </div>
          <div className="px-2">
            <p className="tracking-wider leading-loose text-justify">
              {textCodes.Join.text}
            </p>
            <h1 className="text-xl font-semibold xl:pb-8 pb-4">
              {titleCodes.member.title}
            </h1>
            <p className="font-semibold leading-loose text-justify">
              {textCodes.earnPointsMember.text}
            </p>
            <p className="tracking-wider leading-loose text-justify">
              {textCodes.loyaltyDes1.text}
            </p>

            <p className="tracking-wider leading-loose text-justify">
              {textCodes.loyaltyDes4.text}
            </p>
            <div className="flext justify-between grid grid-cols-2 md:grid-cols-2 lg:grid-cosl-2 xl:grid-cols-2 2xl:grid-cols-2 pt-8">
              <a href="https://apps.apple.com/id/app/bond-myanmar/id1664524177?l=id">
                <img
                  src={imageCodes.appstore.image}
                  alt="appstore"
                  width={180}
                  height={140}
                ></img>
              </a>
              <a href="https://play.google.com/store/apps/details?id=bondmm.piti.member">
                <img
                  src={imageCodes.playstore.image}
                  alt="google playstore"
                  width={180}
                  height={140}
                ></img>
              </a>
            </div>
          </div>
        </div>

        <div className="mx-auto px-4">
          <div className="md:text-center lg:text-center xl:text-center 2xl:text-center text-center">
            <p className="mt-10 text-3xl font-bold leading-8 tracking-tight">
              {titleCodes.reward.title}
            </p>
            <h2 className="tracking-wider leading-loose py-2 text-md mt-4 max-w-2xl md:mx-auto lg:mx-auto xl:mx-auto 2xl:mx-auto">
              {textCodes.reward1.text}
            </h2>
            <p className="pb-8 leading-loose text-center text-gray-400">
              {textCodes.exp.text}
            </p>
          </div>
        </div>
        <div className="px-2 grid grid-cols-2 md:grid-cols-2 lg:gird-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4 pt-10 ">
          <div></div>
          <div class="flex items-center space-x-4 shadow-sm">
            <div class="min-w-0 flex-auto space-y-1 font-semibold">
            <img
              src={imageCodes.logoImg.image}
              alt="Location Icon"
              width="110"
              height="90"
              class="flex-none rounded-lg"
              loading="lazy"
            />
            </div>

            <div class="min-w-0 flex-auto space-y-1 font-semibold">
              <p class=" font-semibold leading-6">
                {textCodes.loyaltyDes2.text}
              </p>
            </div>
          </div>
          <div class="flex items-center space-x-4 shadow-sm">
          <div class="min-w-0 flex-auto space-y-1 font-semibold">
              <p class="font-semibold leading-6">
                {textCodes.rewartText.text}
              </p>
              <p className="leading-loose text-gray-500">
                {textCodes.spent.text}
              </p>
            </div>
          </div>
        </div>
        <div className="px-2 grid grid-cols-2 md:grid-cols-2 lg:gird-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4 pt-10 ">
          <div></div>
          <div class="flex items-center space-x-4 shadow-sm">
            <div class="min-w-0 flex-auto space-y-1 font-semibold">
              <p class="font-semibold leading-6">
                {textCodes.rewartText1.text}
              </p>
              <p className="leading-loose text-gray-500">
                {textCodes.spent.text}
              </p>
            </div>

            <div class="min-w-0 flex-auto space-y-1 font-semibold">
              <p class=" font-semibold leading-6">
                {textCodes.loyaltyDes2.text}
              </p>
            </div>
          </div>
          <div class="flex items-center space-x-4 shadow-sm">
            <img
              src={imageCodes.logoImg.image}
              alt="Location Icon"
              width="110"
              height="90"
              class="flex-none rounded-lg"
              loading="lazy"
            />
          </div>
        </div>
        <div className="px-2 grid grid-cols-2 md:grid-cols-2 lg:gird-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4 pt-10 ">
          <div></div>
          <div class="flex items-center space-x-4 shadow-sm">
            <div class="min-w-0 flex-auto space-y-1 font-semibold">
            <img
              src={imageCodes.logoImg.image}
              alt="Location Icon"
              width="110"
              height="90"
              class="flex-none rounded-lg"
              loading="lazy"
            />
            </div>

            <div class="min-w-0 flex-auto space-y-1 font-semibold">
              <p class=" font-semibold leading-6">
                {textCodes.loyaltyDes2.text}
              </p>
            </div>
          </div>
          <div class="flex items-center space-x-4 shadow-sm">
          <div class="min-w-0 flex-auto space-y-1 font-semibold">
              <p class="font-semibold leading-6">
                {textCodes.rewartText2.text}
              </p>
              <p className="leading-loose text-gray-500">
                {textCodes.spent1.text}
              </p>
            </div>
          </div>
        </div>
      </div>

       {/*                       banner section                */}
       <div className=" hero w-full pb-10">
        <img
          src={imageCodes.banPhoto.image}
          className="py-1"
        />
        <div class="hero-content text-center text-neutral-content">
          <div class="">
            <h1 className="text-md lg:text-2xl xl:text-2xl pt-10 lg:pt-40 xl:pt-40 text-white py-4"></h1>
            <button className="outline outline-offset-2 outline-2 rounded-lg px-10 py-1">
              <a href="https://onelink.to/gfeuqt"> <h1>GET APP </h1></a>
            </button>
           
          </div>
        </div>
      </div>

      {/*                      end of banner section                */}
    </div>
  );
}

export default Membership;
